import React from 'react'

const TINTS = [
  { bg: 'var(--tile-1-bg)', fg: 'var(--tile-1-fg)' },
  { bg: 'var(--tile-2-bg)', fg: 'var(--tile-2-fg)' },
  { bg: 'var(--tile-3-bg)', fg: 'var(--tile-3-fg)' },
  { bg: 'var(--tile-4-bg)', fg: 'var(--tile-4-fg)' },
  { bg: 'var(--tile-5-bg)', fg: 'var(--tile-5-fg)' },
]

export function initials(nameOrEmail: string): string {
  const base = (nameOrEmail || '').trim()
  if (!base) return '?'
  const namePart = base.includes('@') ? base.split('@')[0] : base
  const words = namePart.split(/[\s._-]+/).filter(Boolean)
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
  return namePart.slice(0, 2).toUpperCase()
}

function tintFor(seed: string): { bg: string; fg: string } {
  let h = 0
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0
  return TINTS[h % TINTS.length]
}

interface AvatarProps {
  name: string
  size?: number
  className?: string
}

const Avatar: React.FC<AvatarProps> = ({ name, size = 36, className = '' }) => {
  const tint = tintFor(name)
  return (
    <span
      className={`avatar ${className}`.trim()}
      style={{
        width: size,
        height: size,
        background: tint.bg,
        color: tint.fg,
        fontSize: Math.round(size * 0.38),
      }}
      aria-hidden
    >
      {initials(name)}
    </span>
  )
}

export default Avatar
